import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  id: yup.number().required(),
});

export function useDeleteSmsSnippetMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation(
    (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.delete(HTTP_ENDPOINTS.smsSnippets.deleteOne(req.id));
    },
    {
      ...options,
      onSuccess: () => {
        [QUERY_KEYS.smsSnippets.all, QUERY_KEYS.smsSnippets.paginated].forEach(
          (key) => {
            queryClient.invalidateQueries({
              queryKey: [key],
            });
          },
        );
        options?.onSuccess?.();
      },
    },
  );
}
